import { render, staticRenderFns } from "./AddNewIntegration.vue?vue&type=template&id=053edc28&scoped=true"
import script from "./AddNewIntegration.vue?vue&type=script&lang=js"
export * from "./AddNewIntegration.vue?vue&type=script&lang=js"
import style0 from "./AddNewIntegration.vue?vue&type=style&index=0&id=053edc28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053edc28",
  null
  
)

export default component.exports